import type { SurveyPage } from '../../fetchSurvey/types';
import type { LogicContext } from '../../surveyLogic/types';
import { findLastVisiblePageIndex } from '../../surveyLogic/navigation/findVisiblePageIndex';
import { getNextVisiblePageIndex } from '../../surveyLogic/navigation/getNextVisiblePageIndex';
import { shouldIncludePageInPath } from '../../surveyLogic/visibility';

export type DisplayEmptyPageRelocation =
  | { action: 'navigate'; pageIndex: number }
  | { action: 'submit' };

export function resolveDisplayEmptyPageRelocation(
  pages: SurveyPage[],
  currentPageIndex: number,
  context: LogicContext
): DisplayEmptyPageRelocation | null {
  const questions = pages[currentPageIndex]?.questions ?? [];
  if (shouldIncludePageInPath(questions, context)) {
    return null;
  }

  const nextVisible = getNextVisiblePageIndex(pages, currentPageIndex, context);
  if (nextVisible < pages.length) {
    return { action: 'navigate', pageIndex: nextVisible };
  }

  const lastVisible = findLastVisiblePageIndex(pages, context);
  if (lastVisible >= 0 && currentPageIndex > lastVisible) {
    return { action: 'submit' };
  }

  if (lastVisible >= 0 && currentPageIndex !== lastVisible) {
    return { action: 'navigate', pageIndex: lastVisible };
  }

  return { action: 'submit' };
}
